<template>
  <div>
    <TipMatchPopupContainer
      ref="container"
      :is-showpopup-close="true"
      class="tip-match-popup"
      :popup-title="title"
      :custom-style="popupStyle"
      @onCancel="clickBack"
    >
      <div class="text">
        {{ tips }}
      </div>
      <div class="authorized-item">
        <div class="title">
          头像
        </div>
        <div class="content">
          <img
            class="avatar"
            :src="getCompressImgUrl(userHead, 32, 32)"
          >
          <slot />
          <div class="iconfont icon-back" />
        </div>
      </div>
      <div class="authorized-item">
        <div class="title">
          昵称
        </div>
        <div class="content">
          <input
            v-model="userNick"
            :adjust-position="adjustPosition"
            type="nickname"
            maxlength="16"
            placeholder="请输入昵称（限16个字）"
            @blur="onBlur()"
            @keyboardheightchange="keyboardheightchange"
          >
        </div>
      </div>
      <div
        class="btn-confirm"
        @click="clickConfirm"
      >
        确认
      </div>
    </TipMatchPopupContainer>
  </div>
</template>

<script>
import TipMatchPopupContainer from '@tencent/press-ui/press-popup/press-popup';

export default {
  name: 'UIPersonInfoWeb',
  options: {
    virtualHost: true,
  },
  components: {
    TipMatchPopupContainer,
  },
  props: {
    head: {
      type: String,
      desc: '头像',
      default: '',
    },
    nick: {
      type: String,
      desc: '昵称',
      default: '',
    },
    tips: {
      type: String,
      desc: '提示文案',
      default: '在生成分享图时展示个人信息',
    },
    title: {
      type: String,
      desc: '标题',
      default: '授权头像、昵称',
    },
  },
  data() {
    return {
      userHead: '',
      userNick: '',
      inputBottom: '0', // 输入框底部偏移
      adjustPosition: false, // 输入框静止键盘弹起
    };
  },
  computed: {
    popupStyle() {
      return `bottom: ${this.inputBottom}px;`;
    },
  },
  watch: {
    head: {
      handler(newV) {
        this.userHead = newV;
      },
      immediate: true,
    },
    nick: {
      handler(newV) {
        this.userNick = newV;
      },
      immediate: true,
    },
  },
  methods: {
    onBlur() {
      this.inputBottom = 0;
    },
    // 小程序监听键盘高度
    keyboardheightchange(e) {
      this.inputBottom = e.detail.height ? e.detail.height : 0;
    },
    clickConfirm() {
      this.$emit('clickConfirm', {
        head: this.userHead,
        nick: this.userNick,
      });
    },
    clickBack(...args) {
      this.$emit('clickBack', ...args);
    },
  },
};
</script>

<style lang="scss" scoped src="./css/index.scss"></style>
